// extracted by mini-css-extract-plugin
export default {"tables":"table_tables__o1R3K"};